const MINUTE = 60 * 1000;

const toMs = (scrapedAt) => {
  const n = Number(scrapedAt);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n > 1e12 ? n : n * 1000;
};

export const formatClockAlmaty = (scrapedAt) => {
  const ms = toMs(scrapedAt);
  if (ms == null) return null;
  try {
    return new Date(ms).toLocaleTimeString('ru-KZ', {
      timeZone: 'Asia/Almaty',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return null;
  }
};

export const formatPollAge = (scrapedAt, nowMs = Date.now()) => {
  const ms = toMs(scrapedAt);
  if (ms == null) return null;
  const minutes = Math.max(0, Math.round((nowMs - ms) / MINUTE));
  if (minutes < 1) return 'только что';
  if (minutes === 1) return '1 мин назад';
  return `${minutes} мин назад`;
};

/** «последний опрос 14:32 · 2 мин назад» — без выдуманного «с какого часа нет связи». */
export const lastPollLine = (scrapedAt, nowMs = Date.now()) => {
  const clock = formatClockAlmaty(scrapedAt);
  const age = formatPollAge(scrapedAt, nowMs);
  if (!clock && !age) return null;
  if (clock && age) return `последний опрос ${clock} · ${age}`;
  if (clock) return `последний опрос ${clock}`;
  return `последний опрос ${age}`;
};
